import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { packageData } from "@/mixins/index";
import uploadAPK from '@/components/uploadAPK';
import util from '@/libs/util';
import axios from 'axios';
export default {
  mixins: [popUp, packageData],
  components: {
    uploadAPK: uploadAPK
  },
  data: function data() {
    var _this = this;

    // 自定义文件验证规则
    var validateFile = function validateFile(rule, value, callback) {
      if (_this.rules.file[0].required == false) {
        callback();
        return;
      }

      if (!_this.fileList || _this.fileList.length === 0) {
        callback(new Error('请上传APK文件'));
      } else {
        callback();
      }
    };

    return {
      reqLoading: false,
      dialogFormVisible: false,
      formData: {
        sdk_type: "",
        sdk_version: '',
        file: "",
        sdk_type_id: ''
      },
      formDataParams: null,
      isReWrite: false,
      formDataPrimitive: {},
      formDataMake: {},
      fileList: [],
      otherSdkTypeList: [],
      modifyData: '',
      rules: {
        sdk_type_id: [{
          required: true,
          message: "请选择类型",
          trigger: "blur"
        }],
        sdk_version: [{
          required: true,
          message: "请输入版本",
          trigger: "blur"
        }],
        file: [{
          required: true,
          validator: validateFile,
          message: "请上传文件",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getcommonDataNew(['otherSdkTypeList']);
  },
  watch: {
    'formData.sdk_type_id': function formDataSdk_type_id(val) {
      console.log("val===", val);

      if (val != this.modifyData) {
        this.rules.file[0].required = true;
      } else {
        this.rules.file[0].required = false;
      }
    }
  },
  methods: {
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.modifyData = '';
                _this2.rules.file[0].required = true;

                _this2.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  _this2.formData = _objectSpread({}, datas);
                  _this2.modifyData = data.sdk_type_id;
                  _this2.rules.file[0].required = false;
                }

                _this2.fileList = [];
                _this2.formData.file = "";
                _this2.isReWrite = true;

                _this2.copyData();

                _this2.dialogFormVisible = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleExceed: function handleExceed() {
      this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u4E00\u4E2A\u6587\u4EF6!");
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      this.formData.file = fileList.length ? fileList[0].raw : "";
    },
    handleRemove: function handleRemove(file, fileList) {
      // 从fileList中移除当前文件
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
      this.formData.file = "";
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 100;

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }

      return isLt10M;
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = true;
      this.clearData(isClear);
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = false;
      this.fileList = [];
      this.formData.file = '';
      this.formData = JSON.parse(JSON.stringify(isClear ? this.formDataPrimitive : this.formDataMake));
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.formDataParams = new FormData();
      var paskItem = this.otherSdkTypeList.filter(function (item) {
        return item.id == _this3.formData.sdk_type_id;
      });
      this.formData.sdk_type = paskItem[0].sdk_type;
      Object.keys(this.formData).forEach(function (key) {
        _this3.formDataParams.append(key, _this3.formData[key]);
      });
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this3.reqLoading = true;
                    data = JSON.parse(JSON.stringify(_this3.formData));
                    reqFn = data.id ? 'operation/otherSdkManageUpdate' : 'operation/otherSdkManageAdd'; //新增

                    axios.post(process.env.VUE_APP_API + reqFn, _this3.formDataParams, {
                      headers: {
                        'Content-Type': 'multipart/form-data',
                        "Authorization": 'Bearer ' + (util.cookies.get('token') || '')
                      }
                    }).then(function (res) {
                      if (res.data.status == 200) {
                        _this3.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this3.dialogFormVisible = false;

                        _this3.$emit('change');
                      } else {
                        _this3.$message({
                          message: res.data.message,
                          type: 'error'
                        });
                      }
                    }).finally(function () {
                      _this3.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};